import axios from './http'
import jwt_decode from "jwt-decode";
import store from './store'

import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'
import Nofind from './views/404'
import Login from './views/Login'
import LoginPhone from './views/LoginPhone'
import Home from './views/Home'
import ExamPC from './views/ExamPC'
import ExamPhone from './views/ExamPhone'
import PersonCenter from './views/PersonCenter'
import ArticleShow from './views/ArticleShow'
import TeacherList from './views/TeacherList'
import PaperList from './views/PaperList'
import RecordList from './views/RecordList'
import AchievementView from './views/AchievementView'
import MisTakesList from './views/MisTakesList'
import CourseDetail from './views/CourseDetail'
import CourseList from './views/CourseList'
import MyCourseList from './views/MyCourseList'
import MyLive from './views/MyLive'
import LiveViews from './views/LiveViews'
import QueryInfo from './views/QueryInfo'
import QueryResult from './views/QueryResult'
//手机端
import HomeMobile from './views/Home_M'
import MyCourseList_M from './views/MyCourseList_M'
import CourseDetail_M from './views/CourseDetail_M'
import LiveViews_M from './views/LiveViews_M'
import MyLive_M from './views/MyLive_M'
import PaperList_M from './views/PaperList_M'
import PersonCenter_M from './views/PersonCenter_M'
import SignUp_M from './views/SignUp_M'
import SignUpResult from './views/SignUpResult'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkExactActiveClass: isPhone() ? 'on' : "selected",
  base: process.env.BASE_URL,
  routes: [{
      path: '*',
      name: '/404',
      component: Nofind
    },
    {
      path: '/login',
      name: 'login',
      component: isPhone() ? LoginPhone : Login
    },
    {
      path: '/queryinfo',
      name: 'queryinfo',
      component: isPhone() ? QueryInfo : QueryInfo
    },
    {
      path: '/queryResult',
      name: 'queryResult',
      component: QueryResult
    },
    {
      path: '/exampc/:id',
      name: 'exampc',
      component: ExamPC
    },
    {
      path: '/exam/:id',
      name: 'exam',
      component: ExamPhone
    },
    {
      path: '/achieveview/:id', //考试记录
      name: 'AchievementView',
      component: AchievementView
    },
    {
      path: '/signup',
      name: 'signup',
      component: isPhone() ? SignUp_M : SignUp_M
    },{
      path: '/SignUpResult',
      name: 'SignUpResult',
      component: isPhone() ? SignUpResult : SignUpResult
    },{
      path: '/api/signUpOrders/payresult',
      name: 'SignUpResult',
      component: isPhone() ? SignUpResult : SignUpResult
    },
    {
      path: '/',
      name: 'index',
      component: Index,
      children: [{
          path: '',
          component: isPhone() ? HomeMobile : Home
        },
        {
          path: '/home',
          name: 'home',
          component: Home
        },
        {
          path: '/personcenter',
          name: 'personcenter',
          component: isPhone() ? PersonCenter_M : PersonCenter
        },
        {
          path: '/views/info/:plateId/:articleId', //显示文章内容
          name: 'infoArticle',
          component: ArticleShow
        },
        {
          path: '/views/:plateId', //显示更多文章
          name: 'TeacherList',
          component: TeacherList
        },
        {
          path: '/papercenter', //考试中心
          name: 'PaperList',
          component: isPhone() ? PaperList_M : PaperList
        },
        {
          path: '/examrecord', //考试记录
          name: 'RecordList',
          component: RecordList
        },
        {
          path: '/mistakelist', //错题卡
          name: 'MisTakesList',
          component: MisTakesList
        },
        {
          path: '/courview/info/:id', //课程详情页
          name: 'CourseDetail',
          component: isPhone() ? CourseDetail_M : CourseDetail
        }, {
          path: '/courviews', //课程详情页
          name: 'CourseList',
          component: CourseList
        }, {
          path: '/mycourses', //课程详情页
          name: 'MyCourseList',
          component: isPhone() ? MyCourseList_M : MyCourseList
        }, {
          path: '/liveview', //课程详情页
          name: 'LiveViews',
          component: isPhone() ? LiveViews_M : LiveViews
        }, {
          path: '/mylive/:id', //直播详情页
          name: 'MyLive',
          component: isPhone() ? MyLive_M : MyLive
        },
      ]
    },
  ]
})

//添加路由守卫
router.beforeEach((to, from, next) => {
  console.log("to ==",to)
  let userid = to.query.userid;
  let password = to.query.password;
  if(userid&&password)
  {
    //处理业务逻辑
    axios.post("/api/auth/login", {
      identificationcard:userid,
      password:password,
    }).then((res) => {
      // 登录成功
      const self = this;
      const { token } = res.data;
      localStorage.setItem("eleTokenCustCysd001", token);

      // 解析token
      const decode = jwt_decode(token);
      // 存储数据
      store.dispatch("setIsAutnenticated", !isEmpty(decode));
      store.dispatch("setUser", decode);
      //获取购买的课程
        let arrhasCourse = [];
        for (var i = 0; i <res.data.data.needexaminee.length; i++)
        {
          arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
        }
      //   this.$root.hasCourse =arrhasCourse;
      // this.$root.ischeckface = res.data.data.ischeckface;
      // this.$root.onlymycourse = res.data.data.onlymycourse;
      // this.$root.buytype = res.data.data.buytype;
      if( res.data.data.onlymycourse)
          localStorage.setItem("onlymycourseCySd", "1");
      else
        localStorage.setItem("onlymycourseCySd", "0");
      localStorage.setItem("hasCourseCySd", arrhasCourse.join(","));
      // 页面跳转
      next("/");
    }).catch(err=>{
      console.log(err);
      next("/");
    });
  }else{
    const isLogin = localStorage.eleTokenCustCysd001 ? true : false;
    if (to.path == "/login" || to.path == "/resetpin" || to.path == "/queryinfo" || to.path == "/queryResult" || to.path == "/signup"||to.path.indexOf("/SignUpResult")>-1||to.path.indexOf("/api/signUpOrders")>-1|| to.path.indexOf("/achieveview") > -1) {
      next();
    } else {
      isLogin ? next() : next("/login");
    }
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  
})
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
function isEmpty(value) {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
  );
}
function isPhone() {
  var mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return mobile != null
}
export default router;